




























import { Vue, Component, Prop } from 'vue-property-decorator';
import { TaskStatus } from 'admiral-core';
import TaskStatusIcon from '@/components/tasks/TaskStatusIcon.vue';

@Component({
  components: { TaskStatusIcon },
})
export default class TaskKanbanBoard extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: Number, default: 0 }) itemCount!: number;
  @Prop({ type: Number, default: 0 }) order!: number;
  @Prop({ type: String }) status!: TaskStatus;
}
